import * as React from 'react';
import { Route } from 'react-router';

import loadOnRoute from 'bundles/common/components/loadOnRoute';
import InstructorProfileViewer from 'bundles/partners-graphql/components/InstructorProfileViewer';
import PartnerApp from 'bundles/partners-graphql/components/PartnerApp';
import PartnerPage from 'bundles/partners-graphql/components/PartnerPage';
import PartnerListingPage from 'bundles/partners-graphql/components/listing/PartnerListingPage';

const NotFound = loadOnRoute(() => import('bundles/phoenix/components/NotFound'));

export default (
  <Route name="app" component={PartnerApp} path="/">
    <Route component={InstructorProfileViewer} path="/instructor/:instructorSlug" />
    <Route component={PartnerListingPage} path="/partners" />
    <Route component={PartnerPage} path="/about/partners/preview/:shortName" />
    <Route component={PartnerPage} path="/partners/:shortName" />
    <Route path="*" getComponent={NotFound} />
  </Route>
);
